<template>
    <div class="record-table-reference-number-with-hint">
        <span>{{ text }}</span>
        <span
            v-if="hint !== ''"
            v-b-tooltip.hover.nofade.left.html
            class="record-table-reference-number-with-hint__badge"
            :title="hint">i</span>
    </div>
</template>

<script>
    import {VBTooltip} from 'bootstrap-vue/src';
    import '@desktop/scss/components/record/record-table-reference-number-with-hint.scss';

    export default {
        directives: {
            'b-tooltip': VBTooltip,
        },
        props: {
            hint: {
                type: String,
                default: '',
            },
            text: {
                type: String,
                required: true,
            },
        },
    }
</script>
